module.exports = __webpack_public_path__ + "img/empty-bank-account.1753194e.svg";